<ng-container
    #bonusList="userBonusList"
    lsUserBonusList
>
    <ng-content></ng-content>

    <ng-container *ngrxLet="bonusList.bonusList$; let bonuses">
        @if (bonuses?.length && !isProfilePage()) {
            <span class="bonus-amount__mark _system-p-xs _600">{{ bonuses?.length }}</span>
        }
    </ng-container>
</ng-container>
